<template>
  <Head>
    <Style>
      body {
        font-family: {{ getFontFamily(locale) }}, Arial, sans-serif;
      }
    </Style>
    <LinkFavicon />
    <Link rel="canonical" :href="currentUrl" />
    <Meta name="theme-color" :content="PRIMARY_COLOR" />
    <Meta property="og:locale" :content="$branch.locale" />
    <Meta property="og:site_name" :content="$tt('brand.name')" />
    <Meta property="og:url" :content="currentUrl" />
    <Meta name="selfwork.ru" content="mk8lhfjzzsqsqxpGMfZBKMI3eKnN3yAe8DkcmVVS19V8DT91LP" />
  </Head>
</template>

<script setup lang="ts">
import { PRIMARY_COLOR } from '~/assets/constants';
import { getFontFamily } from '~/helpers/font';
import { stripTrailingSlash } from '~/helpers/routing';

const { buildUrl } = useRouting();
const route = useRoute();
const currentUrl = computed(() => stripTrailingSlash(buildUrl(route.path)));
const { locale } = useLocalization();
</script>